import { Injectable } from '@angular/core';
import { UrlTree, CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AuthenticationState } from '../models/models';

@Injectable({
  providedIn: 'root'
})
export class StartupGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private router: Router
  ) {}

  // Can only enter startup state before authenticationstate is set
  canActivate(): boolean | UrlTree {
    const authState = this.auth.authenticationState.value;
    if (authState === AuthenticationState.NotSet) {
      return true;
    }
    else if (authState === AuthenticationState.NotAuthenticated) {
      return this.router.parseUrl('/sign-in');
    }
    else if (authState === AuthenticationState.NewUser) {
      return this.router.parseUrl('/intro');
    }
    else {
      return this.router.parseUrl('/home');
    }
  }
}
